
// Types of Capture Images
export enum CaptureType {
	REPORT = 'report',
	SMARTTAG = 'smarttag'
}